<template>
  <div class="space-y-4">
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ label }}
        <span v-if="required" class="text-red-500">*</span>
      </label>
      <p v-if="description" class="text-sm text-gray-500 mb-3">{{ description }}</p>
    </div>

    <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
      <button
        v-for="zodiac in zodiacOptions"
        :key="zodiac.value"
        type="button"
        @click="selectZodiac(zodiac.value)"
        :class="[
          'flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all hover:shadow-md',
          selectedZodiac === zodiac.value
            ? 'border-psychology-primary bg-psychology-primary-5 shadow-md'
            : 'border-gray-200 hover:border-psychology-primary-20'
        ]"
      >
        <div class="text-3xl mb-2 text-psychology-primary zodiac-icon-wrapper">{{ zodiac.icon }}</div>
        <div class="text-sm font-medium text-gray-900">{{ zodiac.label }}</div>
        <div class="text-xs text-gray-500 mt-1">{{ zodiac.dateRange }}</div>
        <div v-if="selectedZodiac === zodiac.value" class="mt-2 text-psychology-primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
        </div>
      </button>
    </div>

    <!-- 已选择的星座信息 -->
    <div v-if="selectedZodiac && showSelectedInfo" class="mt-4 p-4 bg-psychology-primary-5 border border-psychology-primary-20 rounded-lg">
      <div class="flex items-center gap-3">
        <div class="text-3xl text-psychology-primary zodiac-icon-wrapper">{{ getSelectedZodiacIcon() }}</div>
        <div class="flex-1">
          <h4 class="font-semibold text-gray-900">{{ getSelectedZodiacName() }}</h4>
          <p class="text-sm text-gray-600 mt-1">{{ getSelectedZodiacDescription() }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ZODIAC_OPTIONS, getZodiacData } from '@/data/zodiacData'

export default {
  name: 'ZodiacSelector',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '选择星座'
    },
    description: {
      type: String,
      default: '请选择您的星座'
    },
    required: {
      type: Boolean,
      default: false
    },
    showSelectedInfo: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedZodiac: this.modelValue || '',
      zodiacOptions: ZODIAC_OPTIONS
    }
  },
  watch: {
    modelValue(newVal) {
      this.selectedZodiac = newVal
    }
  },
  methods: {
    selectZodiac(zodiacKey) {
      this.selectedZodiac = zodiacKey
      this.$emit('update:modelValue', zodiacKey)
    },
    getSelectedZodiacIcon() {
      const zodiac = this.zodiacOptions.find(z => z.value === this.selectedZodiac)
      return zodiac ? zodiac.icon : ''
    },
    getSelectedZodiacName() {
      const zodiac = this.zodiacOptions.find(z => z.value === this.selectedZodiac)
      return zodiac ? zodiac.label : ''
    },
    getSelectedZodiacDescription() {
      const zodiacData = getZodiacData(this.selectedZodiac)
      return zodiacData ? zodiacData.relationship : ''
    }
  }
}
</script>

<style scoped>
/* 星座符号样式优化 - 增强粉色主题视觉效果 */
.zodiac-icon-wrapper {
  /* 添加粉色光晕效果，让星座符号更符合粉色主题 */
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.3));
  /* 确保emoji显示清晰 */
  display: inline-block;
  line-height: 1;
  transition: all 0.3s ease;
}

/* 悬停时增强效果 */
button:hover .zodiac-icon-wrapper {
  transform: scale(1.1);
  filter: drop-shadow(0 4px 8px rgba(255, 105, 180, 0.5));
}

/* 选中状态的星座符号 */
button[class*="border-psychology-primary"] .zodiac-icon-wrapper {
  filter: drop-shadow(0 3px 6px rgba(255, 105, 180, 0.4));
}
</style>
